import SharePointUpload from '../components/psc/lib/SharePointUpload'
import useBrowserTabTitle from '../hooks/useBrowserTabTitle'
import useQualityContents from '../hooks/useQualityContents'

const QaRecordSharePointUpload = () => {
    useBrowserTabTitle('QA Record SharePoint Upload')

    const {
        updateQaRecord,
    } = useQualityContents()

    return (
        <SharePointUpload
            entityType="Record"
            apiPath="qa_records"
            statusField="qa_record_status"
            successCallback={(obj) => updateQaRecord(obj)}
        />
    )
}

export default QaRecordSharePointUpload
